import React from 'react';
import { MapIcon, LayersIcon, ClipboardListIcon, FilterIcon, ListChecksIcon, PrinterIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { toolkit } from '../data/framework';
const icons = [MapIcon, LayersIcon, ClipboardListIcon, FilterIcon, ListChecksIcon, PrinterIcon];
export function Toolkit() {
  return <section className="w-full bg-white px-4 py-16 sm:py-24" data-id="element-364" data-mp="avgb9quaapim">
      <div className="mx-auto max-w-5xl" data-id="element-365" data-mp="axt0mp2dg25p">
        <SectionHeading eyebrow="Plus, Your Complete Periodontal Reference Toolkit" title="The Six Volumes Are Only the Beginning" intro="I’ve also included practical resources designed to make the Perio Blueprint™ framework easier to navigate and use." data-id="element-366" data-mp="5x4z39gio2x8" />

        <ul className="mt-12 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-367" data-mp="2mkqxskjlvvyb">
          {toolkit.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex gap-4" data-id="element-368" data-mp="2ho9024mp0xvh" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand" data-id="element-369" data-mp="2018jarmscw37">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-370" data-mp="24228rpfvmiy7" />
                </span>
                <div data-id="element-371" data-mp="2903teesyaqbs">
                  <h3 className="text-lg font-extrabold text-ink" data-id="element-372" data-mp="28ysmw784f4gz">{t.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-muted" data-id="element-373" data-mp="2dt6leii2xrpv">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xs italic leading-relaxed text-muted" data-id="element-374" data-mp="2np08uwxc75mf">
          Any clinical terminology, criteria, and reference material included in the final product should be checked
          against current professional sources before publication.
        </p>

        <div className="mt-10" data-id="element-375" data-mp="xe5djbxilvp4">
          <CTAButton label="Get Access to All 6 Volumes" data-id="element-376" data-mp="xex05x94wj39" />
        </div>
      </div>
    </section>;
}